<div class="d-flex {{params?.addClass?'buttonPosition ':' justify-content-evenly  mt-1'}}">
  <app-svg-icon  *ngIf="params?.edit"
   [src]="'assets/SVGIcons/editicon.svg'"
   class="d-flex align-items-center hand"
   (click)="handleEditIconClick(params)"
  ></app-svg-icon>
  <!-- (click)="openEditModal(params)" -->

  <app-svg-icon  *ngIf="params?.delete"
   [src]="'assets/SVGIcons/deleteicon.svg'"
   class="d-flex align-items-center hand"
   (click)="handleDeleteIconClick(params)"
   ></app-svg-icon>

   <!-- <app-svg-icon
   [src]="'assets/SVGIcons/grayPreview.svg'"
   class="d-flex align-items-center hand"
   (click)="openPreview(params)"
   ></app-svg-icon> -->
</div>
